import { Button, Select, SelectOption } from "@rio-cloud/rio-uikit";
import DateTimerFilter from "./DateTimerFilter";
import { useNavigate, useLocation } from "react-router";
import { useEffect, useState } from "react";

interface Props {
    handleSearch: (text: string) => void;
    handleSupportType: (subject: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
    handleRegional: (value: string) => void;
    optionsRegionals: SelectOption[];
    search?: string;
    dn?: string;
    responsible?: string;
    regional?: string;
    supportType?: string;
}

const ToollBar = ({ 
    handleSearch, 
    handleSupportType, 
    handleDn, 
    handleResponsible, 
    optionsRegionals,
    handleRegional, 
    search,
    dn,
    regional,
    responsible,
    supportType,
 }: Props) => {
    const [reg, setReg] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (value: string) => {
        handleSearch(value)
    };

    const handleChangeSupportType = (sub?: string) => {
        if (!sub) return;
        handleSupportType(sub);
    }

    const handleChangeDn = (value: string) => {
        handleDn(value)
    };

    const handleChangeResponsible = (value: string) => {
        handleResponsible(value)
    };

    const handleRegionalValue = (value?: string) => {
        if (!value) return;

        handleRegional(value)
    }

    const goToNewSupportCall = () => {
        navigate({
            pathname: location.pathname + '/new-support-call',
        });
    };

    const SupportTypeOptions = [
    {
        id: 'TECHNICAL_SUPPORT',
        label: 'TAS - Suporte Técnico'
    }, {
        id: 'VOLKSTOTAL',
        label: 'Suporte Volkstotal'
    }, {
        id: 'all',
        label: 'Todos'
    }]

    useEffect(() => {
        if (regional) {
            setReg(regional)
        }
    }, [regional])

    return (
        <div className="margin-top-20">
            <div>
                <span className="text-medium text-size-18" style={{ color: "#2A3740" }}>Gestão de solicitacões</span>
            </div>

            <div className="table-toolbar">
                <div className="table-toolbar-container">
                    <div className="table-toolbar-group flex-1-1 align-items-end flex-nowrap">
                        <div className="table-toolbar-column table-toolbar-column-spacer">
                            <Button onClick={goToNewSupportCall} bsStyle={Button.PRIMARY} iconName='rioglyph-plus' style={{ width: 150 }}>Nova solicitação</Button>
                        </div>

                        {/* <div className="table-toolbar-column table-toolbar-column-spacer flex-1-1">
                            <DateTimerFilter />
                        </div> */}

                        <div className="table-toolbar-column table-toolbar-column-spacer w-full">
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Busque por nº de solicitaçao, chassi, placa ou cliente'
                                id="chassisSearch"
                                value={search}
                                onChange={(event) => handleChange(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>

                        <div className="table-toolbar-column table-toolbar-column-spacer w-full">
                            <label htmlFor="assunto">Regional</label>
                            <Select
                                id={`supportType`}
                                placeholder="Selecione"
                                value={[reg]}
                                options={optionsRegionals}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum tipo de assunto encontrado"
                                onChange={(selected) => handleRegionalValue(selected?.id)}
                            />
                        </div>

                        <div className="table-toolbar-column table-toolbar-column-spacer w-full">
                            <label htmlFor="assunto">Tipo de suporte</label>
                            <Select
                                id={`supportType`}
                                placeholder="Selecione"
                                value={[supportType || '']}
                                options={SupportTypeOptions}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum tipo de assunto encontrado"
                                onChange={(selected) => handleChangeSupportType(selected?.id)}
                            />
                        </div>

                        <div className="table-toolbar-column table-toolbar-column-spacer w-full">
                            <label htmlFor="responsible">Responsável</label>
                            {/* <Select
                                id={`responsible`}
                                placeholder="Selecione"
                                value={['']}
                                options={[]}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum responsável encontrado"
                                onChange={(e) => { }}
                            /> */}
                            <input
                                type="text"
                                className="form-control"
                                id="responsible"
                                value={responsible}
                                onChange={(event) => handleChangeResponsible(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>
                        <div className="table-toolbar-column table-toolbar-column-spacer w-full">
                            <label htmlFor="dn">DN</label>
                            {/* <Select
                                id={`dn`}
                                placeholder="Selecione"
                                value={['']}
                                options={[]}
                                useFilter
                                className="border"
                                noItemMessage="Nenhum tipo de falha encontrado"
                                onChange={(e) => { }}
                            /> */}
                            <input
                                type="text"
                                className="form-control"
                                id="dn"
                                value={dn}
                                onChange={(event) => handleChangeDn(event.target.value)}
                                maxLength={17}
                                style={{ height: "34px", minHeight: "34px", maxHeight: "34px", lineHeight: "34px" }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ToollBar;
